// src/hooks/usePageActions.ts
// Register the open page's quick actions in the Right Rail's Actions tab.
// Placement rule: page-level quick actions live in the right drawer, never as
// an inline card on the page itself (see docs/ux/04-right-rail.md).

import { useEffect } from 'react';
import { useTabId } from '@/components/tabs/TabContext';
import { railStore } from '@/stores/RailStore';
import type { PageAction } from '@/features/layout/types';

export function usePageActions(actions: PageAction[]) {
  // Filed under the page's own tab: a page in a background pane keeps its
  // actions to itself instead of putting them on the rail of the tab in front.
  const tabId = useTabId();

  // Re-register after every render so handlers never go stale; MobX only
  // notifies rail observers on reference change, which is what we want.
  useEffect(() => {
    railStore.setPageActions(tabId, actions);
  });

  useEffect(() => () => railStore.clearPageActions(tabId), [tabId]);
}
